import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  cartItems: [],
};

const cakeCartSlice = createSlice({
  name: 'cakeCart',
  initialState,
  reducers: {
    setCartItems: (state, action) => {
      state.cartItems = action.payload;
      localStorage.setItem('selectedCakes', JSON.stringify(action.payload));
    },
    updateQuantity: (state, action) => {
      const { id, change } = action.payload;
      state.cartItems = state.cartItems
        .map((item) =>
          item.id === id ? { ...item, quantity: Math.min(999999, Math.max(0, parseFloat((parseFloat(item.quantity || 0) + parseFloat(change || 0)).toFixed(3)))) } : item
        )
        .filter((item) => item.quantity > 0);
      localStorage.setItem('selectedCakes', JSON.stringify(state.cartItems));
    },
    updateManualQuantity: (state, action) => {
      const { id, value } = action.payload;
      const quantity = Math.min(999999, parseFloat(value));
      if (isNaN(quantity) || quantity < 0) return;
      state.cartItems = state.cartItems.map((item) =>
        item.id === id ? { ...item, quantity } : item
      );
      localStorage.setItem('selectedCakes', JSON.stringify(state.cartItems));
    },
    removeItem: (state, action) => {
      state.cartItems = state.cartItems.filter((item) => item.id !== action.payload);
      localStorage.setItem('selectedCakes', JSON.stringify(state.cartItems));
    },
    addToCart: (state, action) => {
      const product = action.payload;
      const exist = state.cartItems.find((i) => i.id === product.id);

      const unitStr = (product.units || '').toLowerCase();
      const baseWeightMatch = product.name?.match(/(\d+)\s*(g|gm|gram|grams|gms)\b/i);
      const baseWeight = baseWeightMatch ? parseFloat(baseWeightMatch[1]) : null;
      let change = 1;
      const isWeightUnit = unitStr.includes('kg') || unitStr.includes('gram') || /\b(g|gms|gm)\b/.test(unitStr);
      if (baseWeight && baseWeight > 0 && isWeightUnit) {
        change = baseWeight / 1000;
      }

      if (exist) {
        state.cartItems = state.cartItems.map((i) =>
          i.id === product.id ? { ...i, quantity: Math.min(999999, parseFloat((i.quantity + change).toFixed(3))) } : i
        );
      } else {
        state.cartItems = [...state.cartItems, { ...product, quantity: change }];
      }
      localStorage.setItem('selectedCakes', JSON.stringify(state.cartItems));
    },
  },
});

export const { setCartItems, updateQuantity, updateManualQuantity, removeItem, addToCart } =
  cakeCartSlice.actions;

export default cakeCartSlice.reducer;